import React from "react";
import { observer, inject } from "mobx-react";
import { STORE_AUTH } from "../../../../../../constants";
import { Form } from "react-bootstrap";
import { wrapCheckbox } from "../../../../../../common/FormChangeWrapper";
import { AuthStore } from "../../../../../../stores";

interface IProps {
    deliveryType: "delivery" | "pickup";
    isUrgent: boolean;
    setAddressTypeCallback: (deliveryType: "delivery" | "pickup", isUrgent: boolean) => void;
}

@inject(STORE_AUTH)
@observer
export class ConfirmationStep2As extends React.Component<IProps, {}> {
    constructor(props: any) {
        super(props);
    }

    authStore = (this.props as any)[STORE_AUTH] as AuthStore;


    private changeDeliveryTypeHandler = (fieldName: string, value: string, checked: boolean) => {
        if (fieldName == "deliveryType") {
            this.props.setAddressTypeCallback(value as "delivery" | "pickup", this.props.isUrgent && value == "pickup");
        }
        else
            this.props.setAddressTypeCallback(this.props.deliveryType, checked);
    }

    render() {
        return <Form>
            <Form.Check
                type="radio"
                id="delivery_plan"
                name="deliveryType"
                checked={this.props.deliveryType == "delivery"}
                value="delivery"
                label="Плановая доставка"
                onChange={wrapCheckbox(this.changeDeliveryTypeHandler)}
            />
            <Form.Check
                type="radio"
                id="delivery_pickup"
                checked={this.props.deliveryType == "pickup"}
                value="pickup"
                name="deliveryType"
                label="Самовывоз"
                onChange={wrapCheckbox(this.changeDeliveryTypeHandler)}
            />
            {this.props.deliveryType == "pickup" && this.authStore.isCallCentre ?
                <Form.Check
                    type="checkbox"
                    id="delivery_urgent"
                    checked={this.props.isUrgent}
                    name="isUrgent"
                    label="Срочная сборка"
                    onChange={wrapCheckbox(this.changeDeliveryTypeHandler)}
                /> : []}
        </Form>
    }
}